import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('first-cta');
    const handleScroll = () => {
      const threshold = anchor ? anchor.getBoundingClientRect().top + window.scrollY + anchor.offsetHeight : 700;
      setVisible(window.scrollY > threshold);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gold-500/30 bg-navy-950/95 px-3 pb-3 pt-3 backdrop-blur transition-[transform,opacity] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-145" data-mp="2ft3dkvfjlsfu">
      <div className="mx-auto max-w-md" data-id="element-146" data-mp="33inyhjv9azrr">
        <a href={CHECKOUT_URL} className="flex w-full animate-shake items-center justify-center rounded-xl bg-gold-500 px-4 py-3.5 font-display text-base font-700 uppercase tracking-wide text-navy-950 shadow-[0_10px_30px_-10px_rgba(212,162,78,0.8)] transition-colors duration-200 ease-out hover:bg-gold-400 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/50 sm:text-lg" data-id="element-147" data-mp="2z1xwz9ounfnu">
          Get instant access — $27
        </a>
        <p className="mt-1.5 text-center text-[10px] font-medium uppercase tracking-wider text-slate-400" data-id="element-148" data-mp="2fg2xj1uik9sq">
          One-time payment · Lifetime access · 7-day guarantee
        </p>
      </div>
    </div>;
}